import React, { useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, Chip, Modal, img, fmt, when } from "./kit";
import api from "../../util/panelApi";

// Banner ekleme/duzenleme/silme yonetici oturumu ister.
const call = async (path, { method = "GET", form } = {}) => {
  const res = await fetch(`${baseURL}banner${path}`, {
    method,
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" },
    body: form,
  });
  if (res.status === 401) {
    sessionStorage.clear();
    window.location.href = "/";
    return { status: false, message: "Oturum süresi doldu." };
  }
  try {
    return await res.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt" };
  }
};

const toInput = (d) => (d ? new Date(d).toISOString().slice(0, 16) : "");
const empty = { title: "", url: "", sort: 0, isActive: true, startsAt: "", endsAt: "", placement: "home", lang: "" };
const LANGS = { "": "Herkes", tr: "Türkçe", ar: "Arapça", en: "İngilizce" };
const PLACES = { home: "Anasayfa & Parti", recharge: "Coin yükleme", agency: "Ajansa katıl", room: "Oda içi kare (sağ sütun, 4:5)" };

const Banners = () => {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [saving, setSaving] = useState(false);
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    api.officialRooms().then((r) => r?.status && setRooms((r.rooms || []).filter((x) => x.isActive)));
  }, []);

  const load = async () => {
    const r = await call("");
    if (r?.status) setList(r.banner || []);
  };
  useEffect(() => {
    load();
  }, []);

  const open = (b) => {
    setEdit(b ? { ...b, startsAt: toInput(b.startsAt), endsAt: toInput(b.endsAt) } : { ...empty, sort: list.length });
    setFile(null);
    setPreview(b ? img(b.image) : "");
  };

  const pick = (f) => {
    setFile(f);
    setPreview(f ? URL.createObjectURL(f) : edit?._id ? img(edit.image) : "");
  };

  const save = async () => {
    if (!edit._id && !file) return window.alert("Banner görseli seç");
    if (edit.url && !/^(https:\/\/|room:|live:|page:)/.test(edit.url)) return window.alert("Bağlantı https:// ya da room: ile başlamalı");
    setSaving(true);
    const fd = new FormData();
    ["title", "url", "sort", "isActive", "startsAt", "endsAt", "placement", "lang"].forEach((k) => fd.append(k, edit[k] ?? ""));
    if (file) fd.append("image", file);
    const r = edit._id ? await call(`?bannerId=${edit._id}`, { method: "PATCH", form: fd }) : await call("", { method: "POST", form: fd });
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setEdit(null);
    load();
  };

  const toggle = async (b) => {
    const fd = new FormData();
    fd.append("isActive", !(b.isActive !== false));
    await call(`?bannerId=${b._id}`, { method: "PATCH", form: fd });
    load();
  };

  const remove = async (b) => {
    if (!window.confirm("Banner silinsin mi?")) return;
    await call(`?bannerId=${b._id}`, { method: "DELETE" });
    load();
  };

  const move = async (b, dir) => {
    const sorted = [...list];
    const i = sorted.findIndex((x) => x._id === b._id);
    const j = i + dir;
    if (j < 0 || j >= sorted.length) return;
    [sorted[i], sorted[j]] = [sorted[j], sorted[i]];
    await Promise.all(
      sorted.map((x, k) => {
        const fd = new FormData();
        fd.append("sort", k);
        return call(`?bannerId=${x._id}`, { method: "PATCH", form: fd });
      })
    );
    load();
  };

  const status = (b) => {
    const now = Date.now();
    if (b.isActive === false) return <Chip kind="wait">Kapalı</Chip>;
    if (b.startsAt && new Date(b.startsAt) > now) return <Chip kind="wait">Başlamadı</Chip>;
    if (b.endsAt && new Date(b.endsAt) < now) return <Chip kind="bad">Süresi doldu</Chip>;
    return <Chip>Yayında</Chip>;
  };

  return (
    <>
      <PageHead
        title="Banner"
        sub="Uygulamada Canlı (ana sayfa) üstündeki kayan banner. Önerilen boyut 1080×320 px (yaklaşık 10:3). Sıra küçükten büyüğe gösterilir."
        right={
          <button className="btn btn-primary" onClick={() => open(null)}>
            Banner yükle
          </button>
        }
      />

      {list.length === 0 ? (
        <div className="card">
          <div className="badu-empty">Henüz banner yok. Yüklediğin ilk banner uygulamada hemen görünür.</div>
        </div>
      ) : (
        <div className="row">
          {list.map((b, i) => (
            <div className="col-md-6 col-xl-4" key={b._id}>
              <div className="card">
                <div style={{ position: "relative" }}>
                  <img src={img(b.image)} alt="" style={{ width: "100%", aspectRatio: "10 / 3", objectFit: "cover", borderRadius: "12px 12px 0 0", display: "block" }} />
                  <div style={{ position: "absolute", top: 8, left: 8 }}>{status(b)}</div>
                  <div style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,.55)", color: "#fff", borderRadius: 10, padding: "2px 8px", fontSize: 12 }}>
                    #{i + 1}
                  </div>
                </div>
                <div className="card-body" style={{ paddingTop: 10 }}>
                  <b>{b.title || "Başlıksız"}</b> <span style={{ fontSize: 12, color: "#6B7280" }}>· {PLACES[b.placement] || PLACES.home} · {LANGS[b.lang || ""]}</span>
                  <div style={{ fontSize: 12, color: "#6B7280", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {b.url || "Bağlantı yok"}
                  </div>
                  <div style={{ fontSize: 12, color: "#6B7280", marginTop: 4 }}>
                    {b.startsAt ? when(b.startsAt) : "Hemen"} → {b.endsAt ? when(b.endsAt) : "Süresiz"} · {fmt(b.clicks)} tıklama
                  </div>
                  <div className="d-flex" style={{ gap: 6, marginTop: 10, flexWrap: "wrap" }}>
                    <button className="btn btn-sm btn-outline-secondary" disabled={i === 0} onClick={() => move(b, -1)}>
                      ↑
                    </button>
                    <button className="btn btn-sm btn-outline-secondary" disabled={i === list.length - 1} onClick={() => move(b, 1)}>
                      ↓
                    </button>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => open(b)}>
                      Düzenle
                    </button>
                    <button className={`btn btn-sm ${b.isActive !== false ? "btn-outline-warning" : "btn-outline-success"}`} onClick={() => toggle(b)}>
                      {b.isActive !== false ? "Kapat" : "Aç"}
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(b)}>
                      Sil
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={!!edit} title={edit?._id ? "Banner düzenle" : "Banner yükle"} onClose={() => setEdit(null)}>
        {edit && (
          <>
            <label style={{ fontSize: 12 }}>Görsel (1080×320 önerilir)</label>
            <input className="form-control" type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={(e) => pick(e.target.files?.[0] || null)} />
            <div style={{ marginTop: 10, background: "#0C0826", borderRadius: 16, padding: 10 }}>
              <div style={{ fontSize: 11, color: "#9CA3AF", marginBottom: 6 }}>Uygulamadaki görünüm</div>
              {preview ? (
                <img src={preview} alt="" style={{ width: "100%", aspectRatio: "10 / 3", objectFit: "cover", borderRadius: 14, display: "block" }} />
              ) : (
                <div style={{ aspectRatio: "10 / 3", borderRadius: 14, border: "1px dashed #4B5563", display: "flex", alignItems: "center", justifyContent: "center", color: "#6B7280" }}>
                  Görsel seçilmedi
                </div>
              )}
            </div>
            <label style={{ fontSize: 12, marginTop: 10 }}>Başlık (sadece admin için)</label>
            <input className="form-control" value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} />
            <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Nerede görünsün</label>
            <select className="form-control" value={edit.placement || "home"} onChange={(e) => setEdit({ ...edit, placement: e.target.value })}>
              {Object.entries(PLACES).map(([k, v]) => (
                <option key={k} value={k}>
                  {v}
                </option>
              ))}
            </select>
            <label style={{ fontSize: 12, marginTop: 10 }}>Hangi dildeki kullanıcılar görsün</label>
            <select className="form-control" value={edit.lang || ""} onChange={(e) => setEdit({ ...edit, lang: e.target.value })}>
              {Object.entries(LANGS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            <label style={{ fontSize: 12, marginTop: 10 }}>Yönetim odasına bağla (isteğe bağlı)</label>
            <select className="form-control" value={(edit.url || "").startsWith("room:") ? edit.url : ""} onChange={(e) => setEdit({ ...edit, url: e.target.value })}>
              <option value="">— Oda seçme —</option>
              {rooms.map((r) => <option key={r._id} value={`room:${r._id}`}>{r.title}</option>)}
            </select>
            <label style={{ fontSize: 12, marginTop: 10 }}>Tıklanınca açılacak bağlantı (https ya da room:, isteğe bağlı)</label>
            <input className="form-control" placeholder="https://..." value={edit.url} onChange={(e) => setEdit({ ...edit, url: e.target.value })} />
            <div className="d-flex" style={{ gap: 8, marginTop: 10 }}>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12 }}>Başlangıç (boş = hemen)</label>
                <input className="form-control" type="datetime-local" value={edit.startsAt} onChange={(e) => setEdit({ ...edit, startsAt: e.target.value })} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12 }}>Bitiş (boş = süresiz)</label>
                <input className="form-control" type="datetime-local" value={edit.endsAt} onChange={(e) => setEdit({ ...edit, endsAt: e.target.value })} />
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 14 }}>
              <label style={{ margin: 0 }}>
                <input type="checkbox" checked={edit.isActive !== false} onChange={(e) => setEdit({ ...edit, isActive: e.target.checked })} /> Yayında
              </label>
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? "Kaydediliyor…" : "Kaydet"}
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default Banners;
